(() => {
  'use strict';

  const addClasses = (root, selector, ...classes) => {
    root.querySelectorAll(selector).forEach((element) => element.classList.add(...classes));
  };

  const ensureAdvisorStylesAreLast = () => {
    const stylesheet = document.querySelector('link[href*="pw-advisor-runtime.css"]');
    if (!stylesheet || !document.body) return;
    if (document.body.lastElementChild !== stylesheet) document.body.appendChild(stylesheet);
  };

  const mapAdvisor = (advisor) => {
    if (!(advisor instanceof HTMLElement)) return;

    advisor.dataset.pwAdvisorCore = 'true';
    addClasses(advisor, ':scope > .container, .pw-adviser__container', 'pw-container');
    addClasses(advisor, '.pw-adviser__hero, .pw-adviser__panel, .pw-adviser__question-panel', 'pw-product-block');
    addClasses(advisor, '.pw-adviser__eyebrow', 'pw-eyebrow');
    addClasses(advisor, '.pw-adviser__options', 'pw-service-options');
    addClasses(advisor, '.pw-adviser__option', 'pw-service-option');
    addClasses(advisor, '.pw-adviser__next, .btn--primary', 'pw-button');
    addClasses(advisor, '.pw-adviser__back, .btn--secondary', 'pw-button', 'pw-button--secondary');
    addClasses(advisor, '.pw-adviser__results-grid, .pw-adviser__result-grid, .pw-adviser-card-grid, .pw-adviser__cards', 'pw-product-grid');
    addClasses(advisor, '.pw-adviser-card, .pw-adviser__result-card', 'pw-product-card');
    addClasses(advisor, '.pw-adviser-card__image, .pw-adviser__result-image', 'pw-product-card__media');
    addClasses(advisor, '.pw-adviser-card__head, .pw-adviser__result-content', 'pw-product-card__body');
    addClasses(advisor, '.pw-adviser-card__vendor, .pw-adviser__result-vendor', 'pw-product-card__vendor');
    addClasses(advisor, '.pw-adviser-card__title, .pw-adviser__result-content h3', 'pw-product-card__title');
    addClasses(advisor, '.pw-adviser-card__price, .pw-adviser__result-price', 'pw-product-card__price');
    addClasses(advisor, '.pw-adviser-card__footer, .pw-adviser__result-footer', 'pw-product-card__footer');
    addClasses(advisor, '.pw-adviser-card__featured-badge, .pw-adviser__result-badge', 'pw-status-badge');
    addClasses(advisor, '.pw-adviser-card .btn[href*="/products/"], .pw-adviser__result-card .btn[href*="/products/"]', 'pw-button');
  };

  const mapWithin = (root) => {
    if (!(root instanceof Document || root instanceof HTMLElement)) return;
    if (root instanceof HTMLElement && root.matches('.pw-adviser')) mapAdvisor(root);
    root.querySelectorAll('.pw-adviser').forEach(mapAdvisor);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mapWithin(document);
      ensureAdvisorStylesAreLast();
    });
  };

  const start = () => {
    mapWithin(document);
    ensureAdvisorStylesAreLast();

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
